import classNames from "classnames";
import { useContext } from "react";
import { GridTableRow } from "../general/Tables/GridTable/GridTable";
import { TransactionsPairForReconciliation } from "../../common/contracts/reconciliation.contract";
import styles from "./Reconciliation.module.scss";
import { ReconciliationTransaction } from "./ReconciliationTransaction";
import { ReconciliationAction } from "./ReconciliationAction";
import { ReconciliationContext } from "./Reconciliation.context";

interface Props {
    pair: TransactionsPairForReconciliation;
}

export const ReconciliationPair: React.FC<Props> = ({ pair }) => {
    const rowHasDifference = !pair.fromAccount || !pair.fromStatement;
    const { financialTransactionsToRemoveIds, statementTransactionsToAddIds } =
        useContext(ReconciliationContext);

    const isRemoved =
        pair.fromAccount &&
        financialTransactionsToRemoveIds.includes(
            pair.fromAccount.financialTransactionId,
        );
    const isAdded =
        pair.fromStatement &&
        statementTransactionsToAddIds.includes(
            pair.fromStatement.statementTransactionId,
        );

    return (
        <GridTableRow
            columnBorders
            className={classNames({
                [styles.rowWithDifference]: rowHasDifference,
            })}
        >
            <ReconciliationTransaction transaction={pair.fromStatement} />
            <ReconciliationTransaction
                transaction={isAdded ? pair.fromStatement : pair.fromAccount}
                isAdded={isAdded}
                isRemoved={isRemoved}
            />
            <div className={styles.actionsCell}>
                {rowHasDifference && <ReconciliationAction pair={pair} />}
            </div>
        </GridTableRow>
    );
};
